import { Injectable } from '@angular/core';

/**
 * Abre a central de ajuda (FAQ) em nova aba.
 *
 * O Messenger não tem central de ajuda dentro do widget (o `zE.activate` era
 * da API do Chat legado, removido), então FAB e menu lateral sempre abrem a
 * central por URL.
 */
@Injectable({
  providedIn: 'root'
})
export class FaqService {

  /** Central de ajuda (Help Center) do Zendesk. */
  private readonly HELP_CENTER_URL = 'https://mandaenuvemenvio.zendesk.com/hc/pt-br';

  /** Abre a central de ajuda em nova aba. */
  public showFaqWindow(): void {
    this.openInNewTab();
  }

  /** `noopener,noreferrer` evita tab-nabbing. */
  private openInNewTab(): void {
    window.open(this.HELP_CENTER_URL, '_blank', 'noopener,noreferrer');
  }
}
